import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface DiscardChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
}

const titleId = 'discard-changes-dialog-title';
const descriptionId = 'discard-changes-dialog-description';

// Shown only when going back would throw away edits - either they fail validation
// or the save was rejected. A clean or successfully saved step goes back silently.
//
// Uses MUI's Button (real <button> semantics - focusable, activatable with Enter/Space)
// rather than StyledButton, which renders a plain <div> with an onClick when no `form`
// prop is passed and so is not keyboard-operable inside MUI's dialog focus trap.
const DiscardChangesDialog = ({ open, onCancel, onDiscard }: DiscardChangesDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby={titleId}
    aria-describedby={descriptionId}
  >
    <DialogTitle id={titleId}>Discard changes on this step?</DialogTitle>
    <DialogContent>
      <DialogContentText id={descriptionId}>
        The changes on this step could not be saved. Going back will discard them.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel}>Keep editing</Button>
      <Button variant="contained" onClick={onDiscard}>Discard and go back</Button>
    </DialogActions>
  </Dialog>
);

export default DiscardChangesDialog;
